/**
 * Валидация контактных полей чекаута.
 * Правила согласованы с backend (orders.js, customValidators.js).
 */

/**
 * Валидация имени / фамилии.
 * 2–50 символов, только буквы (кириллица/латиница), пробелы, дефисы, апострофы.
 * @param {string} value
 * @returns {string|null} Сообщение об ошибке или null
 */
export function validateName(value) {
  const trimmed = typeof value === 'string' ? value.trim() : '';
  if (!trimmed) return 'Обязательное поле';
  if (trimmed.length < 2 || trimmed.length > 50) {
    return 'От 2 до 50 символов';
  }
  const nameRegex = /^[a-zA-Zа-яА-ЯёЁ\s\-']+$/;
  if (!nameRegex.test(trimmed)) {
    return 'Только буквы, пробелы, дефисы и апострофы';
  }
  return null;
}

/**
 * Валидация российского телефона.
 * Форматы: +7…, 8…, 11 цифр.
 * @param {string} value
 * @returns {string|null} Сообщение об ошибке или null
 */
export function validateRussianPhone(value) {
  const raw = typeof value === 'string' ? value : '';
  if (!raw.trim()) return 'Обязательное поле';
  const cleaned = raw.replace(/[\s\-()+]/g, '');
  const digits = cleaned.replace(/\D/g, '');
  if (digits.length !== 11) return 'Введите корректный российский номер (11 цифр)';
  if (!digits.startsWith('8') && !digits.startsWith('7')) return 'Номер должен начинаться с 7 или 8';
  const phoneRegex = /^(\+?7|8)?(\d{10})$/;
  if (!phoneRegex.test(cleaned)) return 'Неверный формат номера';
  return null;
}

/**
 * Валидация email.
 * @param {string} value
 * @returns {string|null} Сообщение об ошибке или null
 */
export function validateEmail(value) {
  const trimmed = typeof value === 'string' ? value.trim() : '';
  if (!trimmed) return 'Обязательное поле';
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(trimmed)) return 'Введите корректный email';
  return null;
}

/**
 * Валидация всех контактных полей формы.
 * @param {{ firstName: string; lastName: string; phone: string; email: string }} formData
 * @returns {{ firstName?: string; lastName?: string; phone?: string; email?: string }}
 */
export function validateContactFields(formData) {
  const errors = {};
  const firstNameErr = validateName(formData.firstName);
  if (firstNameErr) errors.firstName = firstNameErr;
  const lastNameErr = validateName(formData.lastName);
  if (lastNameErr) errors.lastName = lastNameErr;
  const phoneErr = validateRussianPhone(formData.phone);
  if (phoneErr) errors.phone = phoneErr;
  const emailErr = validateEmail(formData.email);
  if (emailErr) errors.email = emailErr;
  return errors;
}
